import { gql } from "apollo-boost";

const queryDocument = gql`
  query document($guid: ID) {
    document(guid:$guid) {
      id
      guid
      entryType
      title
      customerName
      customerId
      billingCustomerId
      workType
      startDate
      endDate
      expiryDate
      modifiedAt
      source
      documentNumber
      source
      templateId
      templateVersionId
      responseTime
      additionalNotes
      customerComments
      estimatedCost
      userId
      approvalStatus
      lastEmail
      clientContacts
      tenantDateSigned
      clientDateSigned
      tenant {
        guid
        name
        email
        contacts
      } 
      users {
        id
        operatorName
      }
      services {
        id
        guid
        workDescription
        workCost
        manHours
        people
        service
        sortOrder
        isVisible
        status
      }
      attachments {
        guid
        fileName
        filePath
        fileId
        fileSize
        description
        visibility
      }
      comments {
        guid
        comment
        childGuid
        createdAt
      }
      customer {
        id
        displayName
        customerAddress
        workAddress
        email
      }
      emailActivity {
        guid
      }
    }
  }
`;

const queryDocuments = gql`
  query documents($limit: Int!, $offset: Int!, $where: DocumentsWhere, $sort: DocumentsSort) {
    documents(filter: {
      limit: $limit,
      offset: $offset,
      where: $where
      sort: $sort
    }) {
      edges {
        node {
          id
          guid
          title
          entryType
          workType
          startDate
          endDate
          expiryDate
          createdAt
          modifiedAt
          username
          source
          documentNumber
          lastEmail
          status
          approvalStatus
          additionalNotes
          customerComments
          estimatedCost
          templateId
          templateVersionId
          users {
            id
            operatorName
          }
          customer {
            id
            email
            displayName
          }
          billing {
            email
          }
          services {
            guid
            workDescription
            workCost
            isVisible
            service
            status
          }
          statuses {
            title
            status
            operatorName,
            notes
          }
        }
      },
      totalCount
    }
  }
`;

const queryDocumentForm = gql`
  query document($guid: ID) {
    document(guid:$guid) {
      id
      guid
      title
      entryType
      customerName
      customerId
      billingCustomerId
      workType
      startDate
      endDate
      expiryDate
      modifiedAt
      source
      documentNumber
      source
      templateId
      templateVersionId
      responseTime
      additionalNotes
      customerComments
      estimatedCost
      approvalStatus
      userId
      approvalStatus
      clientDateSigned
      clientSignature
      clientFullName
      clientComments
      tenantDateSigned
      tenantSignature
      tenantFullName
      tenantComments
      representativeDateSigned
      representativeSignature
      representativeFullName
      representativeComments
      customer {
        email
      }
      services {
        id
        guid
        workDescription
        workCost
        manHours
        people
        service
        sortOrder
        isVisible
        status
      }
      attachments {
        guid
        fileName
        filePath
        fileId
        fileSize
        description
        visibility
      }
      statuses {
        guid
        operatorName
        createdAt
        notes
        status
        title
      }
      users {
        operatorName
      }
    }
  }
`;

export {
  queryDocument,
  queryDocuments,
  queryDocumentForm
}
